var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasteHarmony(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(-29 -584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(39.426 587.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M441.09,535.926c-.018.481-.052.954-.114,1.4a13.285,13.285,0,0,1-.943,3.481,13.914,13.914,0,0,1-2.953,4.409l.917,4.813-.7.129-.97-5.071c-5.722-4.478-8.954-9.549-9.627-15.085-.856-7.143,2.9-13,4.1-14.664a26.683,26.683,0,0,0,4.508,7.014c.419.5.821.963,1.188,1.453a27.943,27.943,0,0,1,2.088,3.154,21.02,21.02,0,0,1,1.109,2.226,17.647,17.647,0,0,1,1.013,3.094A14.911,14.911,0,0,1,441.09,535.926Z",
    transform: "translate(-426.576 -511.419)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M445.548,545.564l-.734,4.831-.708-.1.786-5.184a32.319,32.319,0,0,1-2.306-4.178,2.229,2.229,0,0,1,.087-.215c.035-.1.079-.206.122-.318l.1-.31.1-.335c.035-.112.07-.224.1-.344s.061-.223.1-.335.052-.249.079-.378c.026-.112.061-.232.079-.352s.052-.267.07-.4.044-.249.061-.378.035-.275.052-.413.035-.258.044-.4.018-.284.026-.43.017-.275.017-.413v-.456c0-.146,0-.284-.009-.43s-.017-.318-.026-.473-.017-.3-.035-.456-.044-.318-.061-.481-.035-.318-.061-.481-.061-.327-.1-.49c-.061-.327-.14-.653-.218-.98-.052-.18-.087-.361-.14-.542s-.114-.344-.175-.516-.1-.361-.175-.541-.14-.361-.2-.533c-.079-.189-.149-.378-.227-.567s-.157-.352-.245-.533c-.087-.2-.175-.4-.271-.6-.087-.172-.192-.352-.28-.524-.079-.146-.148-.284-.218-.421-.035-.052-.052-.1-.087-.155,1.835-6.387,6.858-10.35,8.448-11.468a26.183,26.183,0,0,0,1.948,8.072c.236.6.454,1.169.646,1.754C456.721,539.28,447.9,544.472,445.548,545.564Z",
    transform: "translate(-428.967 -511.41)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M444.518,515.009a1.918,1.918,0,1,0-1.918-1.917A1.919,1.919,0,0,0,444.518,515.009Z",
    transform: "translate(-428.967 -510.893)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 1.273,
    cy: 1.273,
    r: 1.273,
    transform: "translate(10.117 4.942)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M437.313,513.938a1.543,1.543,0,1,0-1.545-1.543A1.546,1.546,0,0,0,437.313,513.938Z",
    transform: "translate(-427.94 -510.852)",
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3984",
    "data-name": "Rectangle 3984",
    width: 45,
    height: 45,
    transform: "translate(29 584)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasteHarmony);
export default __webpack_public_path__ + "static/media/taste-harmony.a0db4231725873919f9e6502039789d3.svg";
export { ForwardRef as ReactComponent };